import { AppDefinitionId } from './app-definition';
import { PageId } from './page';
import { WidgetId } from './widgets';
export const ABOUT = {
    appDefinitionId: AppDefinitionId.About,
    pageId: PageId.About,
    widgetId: WidgetId.About,
};
export const MY_ACCOUNT = {
    appDefinitionId: AppDefinitionId.MyAccount,
    pageId: PageId.MyAccount,
    widgetId: WidgetId.MyAccount,
};
export const ALL_MEMBERS = {
    appDefinitionId: AppDefinitionId.Members,
};
export const BLOG_LIKES = {
    appDefinitionId: AppDefinitionId.Blog,
    pageId: PageId.BlogLikes,
    widgetId: WidgetId.BlogLikes,
};
export const BLOG_COMMENTS = {
    appDefinitionId: AppDefinitionId.Blog,
    pageId: PageId.BlogComments,
    widgetId: WidgetId.BlogComments,
};
export const BLOG_POSTS = {
    appDefinitionId: AppDefinitionId.Blog,
    pageId: PageId.BlogPosts,
    widgetId: WidgetId.BlogPosts,
};
export const FILE_SHARE = {
    appDefinitionId: AppDefinitionId.FileShare,
    pageId: PageId.FileShare,
    widgetId: WidgetId.FileShare,
};
export const FOLLOWERS = {
    appDefinitionId: AppDefinitionId.Followers,
    pageId: PageId.FollowingFollowers,
    widgetId: WidgetId.FollowingFollowers,
};
export const FOLLOWERS_LIGHTBOX = {
    appDefinitionId: AppDefinitionId.ProfilePageBob,
    pageId: PageId.FollowingFollowersLightbox,
    widgetId: WidgetId.FollowingFollowersLightbox,
};
export const FORUM_COMMENTS = {
    appDefinitionId: AppDefinitionId.Forum,
    pageId: PageId.ForumComments,
    widgetId: WidgetId.ForumComments,
};
export const FORUM_POSTS = {
    appDefinitionId: AppDefinitionId.Forum,
    pageId: PageId.ForumPosts,
    widgetId: WidgetId.ForumPosts,
};
export const MY_ADDRESSES = {
    appDefinitionId: AppDefinitionId.Addresses,
    pageId: PageId.MyAddresses,
    widgetId: WidgetId.MyAddresses,
};
export const MY_BOOKINGS = {
    appDefinitionId: AppDefinitionId.Bookings,
    pageId: PageId.MyBookings,
    widgetId: WidgetId.MyBookings,
};
export const MY_BOOKINGS_PAGE = {
    appDefinitionId: AppDefinitionId.Bookings,
    pageId: PageId.MyBookingsPage,
    widgetId: WidgetId.MyBookingsPage,
};
export const MY_DRAFTS = {
    appDefinitionId: AppDefinitionId.Blog,
    pageId: PageId.BlogDrafts,
    widgetId: WidgetId.BlogDrafts,
};
export const MY_POSTS = {
    appDefinitionId: AppDefinitionId.Blog,
    pageId: PageId.MyPosts,
    widgetId: WidgetId.MyPosts,
};
export const MY_EVENTS = {
    appDefinitionId: AppDefinitionId.Events,
    pageId: PageId.Events,
    widgetId: WidgetId.Events,
};
export const MY_ORDERS = {
    appDefinitionId: AppDefinitionId.Stores,
    pageId: PageId.MyOrders,
    widgetId: WidgetId.MyOrders,
};
export const MY_WALLET = {
    appDefinitionId: AppDefinitionId.Wallet,
    pageId: PageId.MyWallet,
    widgetId: WidgetId.MyWallet,
};
export const MY_WISHLIST = {
    appDefinitionId: AppDefinitionId.Stores,
    pageId: PageId.MyWishlist,
    widgetId: WidgetId.MyWishlist,
};
export const NOTIFICATIONS = {
    appDefinitionId: AppDefinitionId.Notifications,
    pageId: PageId.Notifications,
    widgetId: WidgetId.Notifications,
};
export const NOTIFICATIONS_PAGE = {
    appDefinitionId: AppDefinitionId.Notifications,
    pageId: PageId.NotificationsPage,
    widgetId: WidgetId.NotificationsPage,
};
export const SETTINGS = {
    appDefinitionId: AppDefinitionId.Settings,
    pageId: PageId.Settings,
    widgetId: WidgetId.Settings,
};
export const SHARED_GALLERY = {
    appDefinitionId: AppDefinitionId.SharedGallery,
    pageId: PageId.SharedGallery,
    widgetId: WidgetId.SharedGallery,
};
export const MY_SUBSCRIPTIONS = {
    appDefinitionId: AppDefinitionId.Subscriptions,
    pageId: PageId.MySubscriptions,
    widgetId: WidgetId.MySubscriptions,
};
export const MY_CHALLENGES = {
    appDefinitionId: AppDefinitionId.Programs,
    pageId: PageId.MyChallenges,
    widgetId: WidgetId.MyChallenges,
};
export const MY_PROGRAMS = {
    appDefinitionId: AppDefinitionId.Programs,
    pageId: PageId.MyPrograms,
    widgetId: WidgetId.MyPrograms,
};
export const MY_REWARDS = {
    appDefinitionId: AppDefinitionId.Rewards,
    pageId: PageId.MyRewards,
    widgetId: WidgetId.MyRewards,
};
export const MEMBER_SETTINGS_PAGE = {
    appDefinitionId: AppDefinitionId.ProfilePageBob,
    pageId: PageId.SettingsPage,
    widgetId: WidgetId.SettingsPage,
};
export const MEMBER_PAGE = {
    appDefinitionId: AppDefinitionId.ProfilePageBob,
    pageId: PageId.MemberPage,
    widgetId: WidgetId.MemberPage,
};
export const GROUPS = {
    appDefinitionId: AppDefinitionId.Groups,
    pageId: PageId.Groups,
    widgetId: WidgetId.Groups,
};
export const TEST_VERTICAL_PUBLIC_WIDGET = {
    appDefinitionId: AppDefinitionId.TestVertical,
    pageId: PageId.TestPublic,
    widgetId: WidgetId.TestPublic,
};
export const TEST_VERTICAL_PRIVATE_WIDGET = {
    appDefinitionId: AppDefinitionId.TestVertical,
    pageId: PageId.TestPrivate,
    widgetId: WidgetId.TestPrivate,
};
//# sourceMappingURL=index.js.map